module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('blockquote', {
    staticClass: "blockquote"
  }, [_c('form', [_c('fieldset', [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "readOnlyInput"
    }
  }, [_vm._v("Download the latest version of the Helium Dev Client and the \"no ui\" version of the Helium Dev Client")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon",
    attrs: {
      "id": "basic-addon1"
    }
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "id": "readOnlyInput",
      "type": "text",
      "placeholder": _vm.textBlock,
      "readonly": ""
    }
  })]), _vm._v(" "), _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.textBlock),
      expression: "textBlock",
      arg: "copy"
    }, {
      name: "clipboard",
      rawName: "v-clipboard:success",
      value: (_vm.onCopy),
      expression: "onCopy",
      arg: "success"
    }],
    staticClass: "btn btn-primary",
    attrs: {
      "id": "copyToClipBtn",
      "type": "button",
      "data-toggle": "tooltip",
      "title": "Copy Install Script to Clipboard"
    }
  }, [_c('i', {
    staticClass: "fa fa-clipboard"
  }), _vm._v(" To clipboard\n          ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.heliumDevAppUri
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Get JAR\n            ")])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "type": "button"
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.noUIHeliumDevAppUri
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Get JAR\n          ")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item"
  }, [_vm._v("HeliumDevLatestCLI")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dev-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "readOnlyInput"
    }
  }, [_vm._v("Latest version of the Helium Dev Client")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-ui-group"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "readOnlyInput"
    }
  }, [_vm._v("Latest version of the \"no ui\" Helium Dev Client")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bae133e6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/HeliumDevLatestCLI.vue
// module id = 596
// module chunks = 2